// import { mergeMap, map, filter } from "rxjs/operators";
import axios from "axios";
import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import * as ccFun from "../../common/ulti/cookieFunction";
import {
  AUTH_SIGNIN,
  HOST_API,
  SSO_AUTH_API_CITIZEN,
  SSO_AUTH_API_VNEID,
  SSO_AUTH_TOKEN,
} from "../api";
import { AUTHORIZATION_COOKIE } from "../../common/ulti/constants";
import { createAction } from "redux-actions";
import * as cmFun from "common/ulti/commonFunction";
import { SSO_TYPE } from "config";
import { SSO_LOGIN_URL } from "config";
import * as CONSTANTS from "common/ulti/constants";
import { fetchToastNotify } from "./app-reducer";

export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST";
export const FETCH_LOGIN_SSO_REQUEST = "FETCH_LOGIN_SSO_REQUEST";
export const FETCH_LOGIN_SSO_API_REQUEST = "FETCH_LOGIN_SSO_API_REQUEST";
export const FETCH_LOGIN_VNEID_API_REQUEST = "FETCH_LOGIN_VNEID_API_REQUEST";
export const FETCH_LOGOUT_SSO_REQUEST = "FETCH_LOGOUT_SSO_REQUEST";
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS";
export const FETCH_LOGIN_FAILURE = "FETCH_LOGIN_FAILURE";

export const fetchLoginRequest = createAction(FETCH_LOGIN_REQUEST);
export const fetchLoginSSORequest = createAction(FETCH_LOGIN_SSO_REQUEST);
export const fetchLoginSSOApiRequest = createAction(
  FETCH_LOGIN_SSO_API_REQUEST,
);
export const fetchLoginVNEIDApiRequest = createAction(
  FETCH_LOGIN_VNEID_API_REQUEST,
);

export const fetchLogoutSSORequest = createAction(FETCH_LOGOUT_SSO_REQUEST);
export const fetchLoginSuccess = createAction(FETCH_LOGIN_SUCCESS);
export const fetchLoginFailure = createAction(FETCH_LOGIN_FAILURE);

export const fetchLoginEpic = (action$, store) => {
  return action$.pipe(
    ofType(
      FETCH_LOGIN_REQUEST,
      FETCH_LOGIN_SSO_REQUEST,
      FETCH_LOGIN_SSO_API_REQUEST,
      FETCH_LOGIN_VNEID_API_REQUEST,
    ),
    mergeMap((action, store) => {
      if (action.type === FETCH_LOGIN_REQUEST)
        return axios
          .post(`${HOST_API}${AUTH_SIGNIN}`, action.payload)
          .then((res) => {
            if (res.data) {
              return fetchLoginSuccess(res.data);
            } else {
              return fetchLoginFailure({});
            }
          })
          .catch((error) => {
            return fetchLoginFailure({});
          });

      if (action.type === FETCH_LOGIN_SSO_API_REQUEST)
        return axios
          .post(`${SSO_AUTH_API_CITIZEN}`, action.payload)
          .then((res) => {
            if (res.data && res.data.success) {
              return fetchLoginSuccess({
                access_token: res.data.accessToken,
                user: cmFun.parseJwt(res.data.accessToken),
              });
            } else {
              return fetchToastNotify({
                type: CONSTANTS.WARNING,
                data: "Đăng nhập không thành công, tài khoản hoặc mật khẩu không chính xác",
              });
            }
          })
          .catch((error) => {
            return fetchToastNotify({
              type: CONSTANTS.WARNING,
              data:
                error?.response?.data?.message ||
                "Đăng nhập không thành công, tài khoản hoặc mật khẩu không chính xác",
            });
          });

      if (action.type === FETCH_LOGIN_SSO_REQUEST) {
        return axios
          .get(`${SSO_AUTH_TOKEN}?type=${SSO_TYPE}&code=${action.payload.code}`)
          .then((res) => {
            if (res.data) {
              return fetchLoginSuccess({
                ...res.data,
                user: cmFun.parseJwt(res.data.access_token),
              });
            } else {
              window.location.href = `${SSO_LOGIN_URL}${SSO_TYPE}`;
              return fetchLoginFailure({});
            }
          })
          .catch((error) => {
            return fetchLoginFailure({});
          });
      }

      if (action.type === FETCH_LOGIN_VNEID_API_REQUEST)
        return axios
          .post(`${SSO_AUTH_API_VNEID}`, action.payload)
          .then((res) => {
            if (res.data && res.data.success) {
              return fetchLoginSuccess({
                access_token: res.data.accessToken,
                user: cmFun.parseJwt(res.data.accessToken),
              });
            } else {
              return fetchToastNotify({
                type: CONSTANTS.WARNING,
                data: "Đăng nhập không thành công, tài khoản hoặc mật khẩu không chính xác",
              });
            }
          })
          .catch((error) => {
            return fetchLoginFailure({});
          });

      // if (action.type === FETCH_LOGOUT_SSO_REQUEST) {
      //   return axios
      //     .get(`${SSO_AUTH_TOKEN}?type=${SSO_TYPE}&code=${action.payload.code}`)
      //     .then((res) => {
      //       if (res.data) {
      //         return fetchLoginFailure( {});
      //       } else {
      //         return fetchLoginFailure({});
      //       }
      //     })
      //     .catch((error) => {
      //       return fetchLoginFailure({});
      //     });
      // }
    }),
  );
};

export function requestLoginReducer(LoginReq = {}, action) {
  switch (action.type) {
    case FETCH_LOGIN_REQUEST:
      return action.payload;
    default:
      return LoginReq;
  }
}

export function fetchLoginReducer(LoginRes = {}, action) {
  switch (action.type) {
    case FETCH_LOGIN_SUCCESS:
      ccFun.setCookie(
        AUTHORIZATION_COOKIE,
        cmFun.encode(JSON.stringify(action.payload)),
      );
      return action.payload;
    case FETCH_LOGIN_FAILURE:
      ccFun.deleteCookie(AUTHORIZATION_COOKIE);
      // Removed ccFun.deleteCookie("redirectAfterLogin") to prevent wiping out valid redirect requests
      return action.payload;
    default:
      return LoginRes;
  }
}
